import * as React from 'react';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';

import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { sortDocumentsDescending } from 'Utility/documentHandling';

const _BPDash = ({ documents }: IOwnProps): React.JSX.Element | undefined => {
  const sortedArr = documents.toSorted(sortDocumentsDescending);
  return (
    <TileContentMaker
      type="recentList"
      data={sortedArr.map(d => ({
        key: d._id,
        date: 'date' in d && isPartialDate(d.date) ? formatPartialDate(d.date) : '',
        title: '',
        value: '',
      }))}
    />
  );
};

interface IOwnProps {
  documents: Array<IDocumentV2>;
}

export default _BPDash;
